import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=03b24e86&scoped=true&"
import script from "./CtaButton.vue?vue&type=script&lang=js&"
export * from "./CtaButton.vue?vue&type=script&lang=js&"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=03b24e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b24e86",
  null
  
)

export default component.exports